<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data(){
    return {
    }
  },
}
</script>

<style lang="less">
*{
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
}

html,body{
  width: 100%;
  height: 100%;
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", '微软雅黑', Arial, sans-serif;
}

</style>



// WEBPACK FOOTER //
// src/App.vue